/**
 * Whether a field holds enough text for the AI to have something to rewrite.
 *
 * A non-empty check is too weak for builder fields: people fill optional
 * inputs with a placeholder dash, and given "-" the model returns generic
 * guidance ("Tuliskan ringkasan singkat yang...") rather than a rewrite. Shown
 * as a before/after that reads as the product producing filler.
 *
 * Four words is the floor for something that can be meaningfully rephrased.
 */
export function hasSubstance(value: string | null | undefined): boolean {
  if (typeof value !== "string") return false;
  return value.trim().split(/\s+/).filter(Boolean).length >= 4;
}
